// Recovered compiled webpack factory 60895. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "applyRouterStatePatchToTree", {
      enumerable: !0,
      get: function () {
        return function e(t, r, n, l) {
          let u,
            [c, f, d, p, h] = r;
          if (1 === t.length) {
            let e = s(r, n);
            return ((0, i.addRefreshMarkerToActiveParallelSegments)(e, l), e);
          }
          let [_, m] = t;
          if (!(0, o.matchSegment)(_, c)) return null;
          if (2 === t.length) u = s(f[m], n);
          else if (null === (u = e((0, a.getNextFlightSegmentPath)(t), f[m], n, l))) return null;
          let g = [t[0], { ...f, [m]: u }, d, p];
          return (h && (g[4] = !0), (0, i.addRefreshMarkerToActiveParallelSegments)(g, l), g);
        };
      },
    }));
  let n = r(65360),
    a = r(16378),
    o = r(7460),
    i = r(23597);
  function s(e, t) {
    let [r, a] = e,
      [i, l] = t;
    if (i === n.DEFAULT_SEGMENT_KEY && r !== n.DEFAULT_SEGMENT_KEY) return e;
    if ((0, o.matchSegment)(r, i)) {
      let t = {};
      for (let e in a) void 0 !== l[e] ? (t[e] = s(a[e], l[e])) : (t[e] = a[e]);
      for (let e in l) t[e] || (t[e] = l[e]);
      let n = [r, t];
      return (e[2] && (n[2] = e[2]), e[3] && (n[3] = e[3]), e[4] && (n[4] = e[4]), n);
    }
    return t;
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
